import {
  JobOfferDetailModel,
  JobsSearchListModel,
  IJobOfferDetail,
  IJobsSearchList,
  IJobsOffer,
  IJobsPlanning,
  IJobSalary,
  IJobEtab,
  IJobPlanningDays,
  IJobClothing,
  IJobsOffersStatus,
} from "@core/models";

export const jobOffersMock = {
  [IJobsSearchList.total]: 2,
  [IJobsSearchList.jobsOffers]: [
    {
      [IJobsOffer.id]: "34051874492251",
      [IJobsOffer.picture]: "https://picsum.photos/id/311/874/367",
      [IJobsOffer.city]: "Paris",
      [IJobsOffer.postalCode]: "75018",
      [IJobsOffer.contractType]: "auto_e",
      [IJobsOffer.duration]: "1 jour",
      [IJobsOffer.publicationDate]: "2022-07-06 15:32:36",
      [IJobsOffer.startDate]: "2022-07-16 09:00:00",
      [IJobsOffer.qualification]: "Serveur",
      [IJobsOffer.salary]: { [IJobSalary.amount]: 15, [IJobSalary.forecast]: 112.5 },
      [IJobsOffer.etab]: { [IJobEtab.category]: "Restaurant Italien" },
      [IJobsOffer.typicalSchedule]: { [IJobsPlanning.schedule]: "18h00-2h00" },
      [IJobsOffer.url]: "serveur-restaurant-italien-34051874492251",
    },
    {
      [IJobsOffer.id]: "34051320900001",
      [IJobsOffer.picture]: "https://picsum.photos/id/1060/874/367",
      [IJobsOffer.city]: "Saint Cyr Sur Loire",
      [IJobsOffer.postalCode]: "37540",
      [IJobsOffer.contractType]: "cdi",
      [IJobsOffer.typicalSchedule]: "39 heures / semaine",
      [IJobsOffer.publicationDate]: "2022-07-06 15:31:19",
      [IJobsOffer.startDate]: "2022-07-16 09:00:00",
      [IJobsOffer.qualification]: "Chef de rang",
      [IJobsOffer.salary]: { [IJobSalary.amount]: "1800", [IJobSalary.periodicity]: "Net / Mois" },
      [IJobsOffer.etab]: { [IJobEtab.name]: "Chez Franklyn", [IJobEtab.category]: "Brasserie Chic" },
      [IJobsOffer.typicalSchedule]: { [IJobsPlanning.fluctuating]: true, [IJobsPlanning.schedule]: "39h / semaine" },
      [IJobsOffer.url]: "serveur-brasserie-chic-34051320900001",
    },
  ],
};

export const jobOfferDetailCDI = new JobOfferDetailModel({
  [IJobsOffer.id]: "34131084516001",
  [IJobsOffer.picture]: "https://picsum.photos/id/395/874/367",
  [IJobsOffer.city]: "Paris",
  [IJobsOffer.postalCode]: "75011",
  [IJobsOffer.contractType]: "cdi",
  [IJobsOffer.publicationDate]: "2022-07-12 14:55:28",
  [IJobsOffer.startDate]: "2022-07-22 09:00:00",
  [IJobsOffer.qualification]: "Chef de rang",
  [IJobsOffer.salary]: {
    [IJobSalary.periodicity]: "Net / Mois",
    [IJobSalary.fluctuating]: true,
    [IJobSalary.periodUnit]: "MONTH",
  },
  [IJobsOffer.etab]: {
    [IJobEtab.category]: "Traiteur",
  },
  [IJobsOffer.typicalSchedule]: {
    [IJobsPlanning.fluctuating]: true,
    [IJobsPlanning.schedule]: [
      { [IJobPlanningDays.id]: 2, [IJobPlanningDays.label]: "Mardi" },
      { [IJobPlanningDays.id]: 3, [IJobPlanningDays.label]: "Mercredi" },
    ],
  },
  [IJobOfferDetail.shifts]: [],
  [IJobOfferDetail.clothing]: {
    [IJobClothing.provided]: false,
    [IJobClothing.outfits]: [],
  },
  [IJobOfferDetail.isExpired]: false,
  [IJobsOffer.precision]:
    "Responsable d'un groupe de tables, vous devez veiller au bon d\u00e9roulement du service sur l\u2019ensemble de ces tables. Sous la responsabilit\u00e9 du ma\u00eetre d'h\u00f4tel, vous serez amen\u00e9 \u00e0 superviser les serveurs et runners positionn\u00e9s sur votre rang. Les missions principales seront :\n- D\u00e9velopper une relation avec la client\u00e8le\n- Mise en place du service\n- Accuellir et accompagner les clients\n- Prendre les commandes, servir et encaisser",
  [IJobOfferDetail.enrichedDescription]:
    "CDI - Traiteur<br><br>D\u00e9but le vendredi 22 juillet 2022<br><br>Dur\u00e9e : 2 jour(s)<br><br>Planning : <br><br>- Mardi de 0h \u00e0 0h<br>- Mercredi de 0h \u00e0 0h<br><br>Pr\u00e9cision: <br><br>Responsable d'un groupe de tables, vous devez veiller au bon d\u00e9roulement du service sur l\u2019ensemble de ces tables. Sous la responsabilit\u00e9 du ma\u00eetre d'h\u00f4tel, vous serez amen\u00e9 \u00e0 superviser les serveurs et runners positionn\u00e9s sur votre rang. Les missions principales seront :\n- D\u00e9velopper une relation avec la client\u00e8le\n- Mise en place du service\n- Accuellir et accompagner les clients\n- Prendre les commandes, servir et encaisser<br><p>Avec Extracadabra, trouver un job en extra, saisonnier ou CDI n&rsquo;est plus un probl&egrave;me !</p>\n<ul>\n<li>Travaille dans toute la France parmi nos 10 000 &eacute;tablissements partenaires</li>\n<li>En h&ocirc;tellerie restauration, vente, logistique, sant&eacute;&hellip;</li>\n<li>Re&ccedil;ois instantan&eacute;ment nos offres correspondant &agrave; tes souhaits et postule \u00e0 celles qui te plaisent</li>\n<li>Une fois s&eacute;lectionn&eacute, tu peux directement travailler</li>\n<li>Re&ccedil;ois ton virement bancaire toutes les 15 jours pour les extras en auto-entrepreneur</li>\n</ul>",
  [IJobsOffer.applicationStatus]: {
    [IJobsOffersStatus.status]: "apply",
    [IJobsOffersStatus.link]: "https://candidat-dev.extracadabra.com/#/apply/34131084516001",
  },
});

export const jobsOffersListMock = new JobsSearchListModel(jobOffersMock);
